<div class="redirect-container">
  <div class="redirect-mat-spinner"> 
    <mat-spinner *ngIf="isSpinnerShown"></mat-spinner>
    <div class="text" *ngIf="redirectionText">{{redirectionText}}</div>
    <div class="text">{{redirectionSubText}}</div>
  </div>
</div>
